<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM | Deactivated Users</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="View and manage deactivated users" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Deactivated Users</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="dashboard">Dashboards</a></li>
                    <li class="breadcrumb-item active">Deactivated Users</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Deactivated Users table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">Deactivated Users Register</h4>
                    <div class="d-flex">
                      <button @click="refreshData" type="button" class="btn btn-primary text-uppercase me-2">
                        <i class="mdi mdi-refresh font-size-16"></i> <span class="pl-1 d-md-inline">Refresh</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search and Filter Section -->
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchTerm" @input="searchUsers" type="text" class="form-control" placeholder="Search by name, username, or email...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <select v-model="selectedDepartment" @change="filterUsers" class="form-select">
                        <option value="">All Departments</option>
                        <option v-for="dept in departments" :key="dept.department_id" :value="dept.department_id">
                          {{ dept.department_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <select v-model="selectedRole" @change="filterUsers" class="form-select">
                        <option value="">All Roles</option>
                        <option v-for="role in roles" :key="role.role_id" :value="role.role_id">
                          {{ role.role_name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading deactivated users...</p>
                  </div>

                  <!-- Error State -->
                  <div v-else-if="error" class="alert alert-danger" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{ errorMessage }}
                    <button @click="fetchDeactivatedUsers" class="btn btn-sm btn-danger float-end">Retry</button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover dt-responsive contacts-table">
                      <thead class="table-light text-uppercase">
                      <tr>
                        <th scope="col">System User</th>
                        <th scope="col">User role</th>
                        <th scope="col">Department</th>
                        <th scope="col">Deactivated On</th>
                        <th>Deactivated By</th>
                        <th scope="col">Deactivation Reason</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody class="text-uppercase">
                      <tr v-if="filteredUsers.length === 0">
                        <td colspan="7" class="text-center py-4">
                          <p class="mb-0 text-muted">No deactivated users found</p>
                        </td>
                      </tr>
                      <tr v-for="user in filteredUsers" :key="user.user_id">
                        <td>
                          <a :href="`user-details/${user.user_id}`">
                            <div class="d-flex align-items-center">
                              <div class="avatar-xs mr-15px">
                                    <span class="avatar-title rounded-circle">
                                      {{ getInitials(user.first_name, user.last_name) }}
                                    </span>
                              </div>
                              <div>
                                <h5 class="font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark">
                                    {{ user.title }} {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">{{ user.email }}</p>
                              </div>
                            </div>
                          </a>
                        </td>
                        <td>{{ user.role_name }}</td>
                        <td>{{ user.department_name || 'N/A' }}</td>
                        <td>{{ formatDate(user.deactivation_date) }}</td>
                        <td>{{ user.deactivated_by || 'System' }}</td>
                        <td>{{ user.deactivation_reason || 'Not specified' }}</td>
                        <td>
                          <button
                              @click="showReactivationModal(user)"
                              class="btn-sm btn-success btn text-uppercase"
                              :disabled="reactivating"
                          >
                            Activate
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination -->
                    <div v-if="totalUsers > limit" class="row mt-4">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ offset + 1 }} to {{ Math.min(offset + limit, totalUsers) }} of {{ totalUsers }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: offset === 0 }">
                              <a @click="previousPage" href="#" class="page-link">Previous</a>
                            </li>
                            <li
                                v-for="page in displayedPages"
                                :key="page"
                                class="paginate_button page-item"
                                :class="{ active: page === currentPage }"
                            >
                              <a @click="goToPage(page)" href="#" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: offset + limit >= totalUsers }">
                              <a @click="nextPage" href="#" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Reactivation Modal -->
      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Reactivate User Account</h4>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body" v-if="selectedUser">
              <p class="text-black fw-bold fs-5">
                Are you sure you want to reactivate the user account for
                <strong class="text-primary">{{ selectedUser.first_name }} {{ selectedUser.last_name }}</strong>?
              </p>

              <div class="alert alert-warning" role="alert">
                <h4 class="alert-heading">Deactivation Details</h4>
                <p class="text-black mb-1"><strong>Reason:</strong> {{ selectedUser.deactivation_reason || 'Not specified' }}</p>
                <p class="text-black mb-1"><strong>Deactivated On:</strong> {{ formatDate(selectedUser.deactivation_date) }}</p>
                <p class="text-black mb-0"><strong>Deactivated By:</strong> {{ selectedUser.deactivated_by || 'System' }}</p>
              </div>

              <div class="mb-3">
                <label for="reactivationReason" class="form-label">Reactivation Reason (Optional)</label>
                <textarea
                    v-model="reactivationReason"
                    class="form-control"
                    id="reactivationReason"
                    rows="3"
                    placeholder="Enter reason for reactivation..."
                ></textarea>
              </div>

              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    @click="confirmReactivation"
                    :disabled="reactivating"
                    class="btn btn-success waves-effect waves-light"
                >
                  <span v-if="reactivating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ reactivating ? 'Processing...' : 'Confirm Reactivation' }}
                </button>
                <button
                    type="button"
                    class="btn btn-secondary waves-effect"
                    @click="closeModal"
                    :disabled="reactivating"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "UsersDeactivated",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      error: false,
      errorMessage: '',
      reactivating: false,

      // Data
      users: [],
      filteredUsers: [],
      departments: [],
      roles: [],

      // Pagination
      limit: 10,
      offset: 0,
      totalUsers: 0,
      currentPage: 1,

      // Filters
      searchTerm: '',
      selectedDepartment: '',
      selectedRole: '',

      // Modal
      showModal: false,
      selectedUser: null,
      reactivationReason: '',

      // Alert
      alert: {
        show: false,
        type: 'success',
        message: ''
      }
    };
  },

  mounted() {
    this.fetchInitialData();
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalUsers / this.limit);
    },

    displayedPages() {
      const pages = [];
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(this.totalPages, startPage + 4);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  methods: {
    // Fetch initial data
    async fetchInitialData() {
      await Promise.all([
        this.fetchDeactivatedUsers(),
        this.fetchDepartments(),
        this.fetchRoles()
      ]);
    },

    // Fetch deactivated users
    async fetchDeactivatedUsers() {
      this.loading = true;
      this.error = false;

      const data = {
        function: "getUsers",
        status: "inactive",
        limit: this.limit,
        offset: this.offset
      };

      if (this.searchTerm) {
        data.searchTerm = this.searchTerm;
      }

      if (this.selectedDepartment) {
        data.departmentId = this.selectedDepartment;
      }

      if (this.selectedRole) {
        data.roleId = this.selectedRole;
      }

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.users = response.data.data.users || [];
          this.filteredUsers = this.users;
          this.totalUsers = response.data.data.total || 0;
        } else {
          this.error = true;
          this.errorMessage = response.data.message || 'Failed to load deactivated users';
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = error.message || 'An error occurred while loading users';
      } finally {
        this.loading = false;
      }
    },

    // Fetch departments
    async fetchDepartments() {
      const data = {
        function: "getDepartments",
        status: "active"
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.departments = response.data.data.departments || [];
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    },

    // Fetch roles
    async fetchRoles() {
      const data = {
        function: "getRoles"
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.roles = response.data.data.roles || [];
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    },

    // Search users
    searchUsers() {
      // Reset to first page when searching
      this.offset = 0;
      this.currentPage = 1;
      this.fetchDeactivatedUsers();
    },

    // Filter users
    filterUsers() {
      // Reset to first page when filtering
      this.offset = 0;
      this.currentPage = 1;
      this.fetchDeactivatedUsers();
    },

    // Refresh data
    refreshData() {
      this.searchTerm = '';
      this.selectedDepartment = '';
      this.selectedRole = '';
      this.offset = 0;
      this.currentPage = 1;
      this.fetchDeactivatedUsers();
    },

    // Show reactivation modal
    showReactivationModal(user) {
      this.selectedUser = user;
      this.reactivationReason = '';
      this.showModal = true;
      this.alert.show = false;
    },

    // Close modal
    closeModal() {
      this.showModal = false;
      this.selectedUser = null;
      this.reactivationReason = '';
      this.alert.show = false;
    },

    // Confirm reactivation
    async confirmReactivation() {
      if (!this.selectedUser) return;

      this.reactivating = true;
      this.alert.show = false;

      const data = {
        function: "updateUser",
        userId: this.selectedUser.user_id,
        isActive: true,
        notes: this.reactivationReason || 'User reactivated'
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.alert.show = true;
          this.alert.type = 'success';
          this.alert.message = 'User account reactivated successfully!';

          // Wait for alert to be visible, then refresh and close
          setTimeout(() => {
            this.closeModal();
            this.fetchDeactivatedUsers();
          }, 2000);
        } else {
          this.alert.show = true;
          this.alert.type = 'danger';
          this.alert.message = response.data.message || 'Failed to reactivate user account';
        }
      } catch (error) {
        this.alert.show = true;
        this.alert.type = 'danger';
        this.alert.message = error.message || 'An error occurred while reactivating the account';
      } finally {
        this.reactivating = false;
      }
    },

    // Pagination methods
    previousPage() {
      if (this.offset > 0) {
        this.offset = Math.max(0, this.offset - this.limit);
        this.currentPage--;
        this.fetchDeactivatedUsers();
      }
    },

    nextPage() {
      if (this.offset + this.limit < this.totalUsers) {
        this.offset += this.limit;
        this.currentPage++;
        this.fetchDeactivatedUsers();
      }
    },

    goToPage(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.limit;
      this.fetchDeactivatedUsers();
    },

    // Helper methods
    getInitials(firstName, lastName) {
      const first = firstName ? firstName.charAt(0).toUpperCase() : '';
      const last = lastName ? lastName.charAt(0).toUpperCase() : '';
      return first + last;
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';

      const date = new Date(dateString);
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };

      return date.toLocaleDateString('en-US', options);
    }
  }
};
</script>

<style scoped>
.search-box {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

.search-box input {
  padding-left: 35px;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 500;
  background-color: #556ee6;
  color: #fff;
}

.mr-15px {
  margin-right: 15px;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.6;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}

.modal.show {
  display: block !important;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>